__turbopack_context__.v({
  "button": "reset-password-form-module-scss-module__SCMrGW__button",
  "controls": "reset-password-form-module-scss-module__SCMrGW__controls",
});
